type DateInput = Date | string | number | null | undefined

const PLACEHOLDER = '—'
const LOCALE = 'en-US'

const listFmt = new Intl.DateTimeFormat(LOCALE, {
  month: 'short',
  day: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
})

const auditFmt = new Intl.DateTimeFormat(LOCALE, {
  month: 'short',
  day: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
})

const dateFmt = new Intl.DateTimeFormat(LOCALE, {
  month: 'short',
  day: 'numeric',
  year: 'numeric',
})

const chartFmt = new Intl.DateTimeFormat(LOCALE, {
  month: 'short',
  day: 'numeric',
})

function toDate(v: DateInput): Date | null {
  if (v == null) return null
  const d = v instanceof Date ? v : new Date(v)
  return Number.isNaN(d.getTime()) ? null : d
}

export function formatListTimestamp(v: DateInput): string {
  const d = toDate(v)
  return d ? listFmt.format(d) : PLACEHOLDER
}

export function formatAuditTimestamp(v: DateInput): string {
  const d = toDate(v)
  return d ? auditFmt.format(d) : PLACEHOLDER
}

export function formatDate(v: DateInput): string {
  const d = toDate(v)
  return d ? dateFmt.format(d) : PLACEHOLDER
}

export function formatChartDate(v: DateInput): string {
  const d = toDate(v)
  return d ? chartFmt.format(d) : PLACEHOLDER
}

export function formatRelativeTime(v: DateInput): string {
  const d = toDate(v)
  if (!d) return PLACEHOLDER
  const diffSec = Math.floor((Date.now() - d.getTime()) / 1000)
  if (diffSec < 60) return 'just now'
  if (diffSec < 3600) return `${Math.floor(diffSec / 60)}m ago`
  if (diffSec < 86400) return `${Math.floor(diffSec / 3600)}h ago`
  return `${Math.floor(diffSec / 86400)}d ago`
}
